var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudsync(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 160,
    viewBox: "0 0 201 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.276 90.6557C186.895 84.6593 184.978 78.8619 181.708 73.8208C178.439 68.7797 173.928 64.6645 168.608 61.8708C172.097 54.2611 172.743 45.6533 170.431 37.6077C168.118 29.5622 163 22.6115 156.003 18.0156C149.006 13.4196 140.594 11.4827 132.292 12.5558C123.99 13.6289 116.347 17.6411 110.749 23.8651C107.357 15.7056 101.006 9.12969 92.9697 5.4558C84.9332 1.78191 75.805 1.28157 67.4152 4.05509C59.0253 6.8286 51.9939 12.671 47.7306 20.4109C43.4673 28.1508 42.2873 37.2162 44.427 45.7896C43.3732 45.6895 42.2614 45.6316 41.1602 45.6316C35.7061 45.6315 30.3273 46.9054 25.4527 49.3518C20.578 51.7982 16.3421 55.3495 13.0827 59.7225C9.82323 64.0956 7.63032 69.1695 6.67872 74.54C5.72712 79.9104 6.04313 85.4289 7.60157 90.6557H187.276Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60166 90.6562H187.277C187.203 89.5128 187.076 88.3799 186.897 87.2734H6.77441C6.9935 88.4141 7.26959 89.5431 7.60166 90.6562Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9811 33.7133L66.2509 33.1337L65.9822 31.611L64.5806 31.5003C64.4036 31.0291 64.1663 30.5827 63.8746 30.1725L64.6017 28.9501L63.5058 27.8541L62.2728 28.5865C61.5662 28.1041 60.7652 27.7773 59.9228 27.6275L59.5698 26.2207H58.0207L57.6624 27.6328C57.1812 27.7251 56.7126 27.8737 56.2661 28.0754L55.1596 27.1164L53.8897 28.0122L54.4166 29.3821C54.0778 29.7324 53.7791 30.1195 53.5262 30.5361L52.0719 30.3885L51.545 31.8428L52.7516 32.6648C52.6951 33.0132 52.6669 33.3656 52.6673 33.7186C52.6673 33.8661 52.6673 34.0084 52.6673 34.1559L51.3975 34.862L51.7979 36.3584H53.2364C53.4463 36.8078 53.7118 37.2291 54.0267 37.6124L53.405 38.9033L54.5905 39.8992L55.7444 39.0772C56.1831 39.3087 56.6485 39.4857 57.1302 39.6041L57.3568 40.9899L58.9006 41.1269L59.3695 39.8149C59.876 39.7679 60.3749 39.66 60.8554 39.4935L61.8302 40.4788L63.1685 39.7042L62.7997 38.3712C63.1967 38.0428 63.5508 37.6657 63.8535 37.2488L65.2182 37.4965L65.8716 36.0949L64.8178 35.2097C64.9333 34.7195 64.9881 34.2169 64.9811 33.7133ZM62.6891 33.7133C62.6901 34.4795 62.4639 35.2288 62.0389 35.8663C61.614 36.5039 61.0096 37.0011 60.302 37.295C59.5944 37.589 58.8156 37.6664 58.064 37.5176C57.3124 37.3687 56.6219 37.0003 56.0797 36.4589C55.5376 35.9175 55.1682 35.2274 55.0183 34.4761C54.8685 33.7247 54.9449 32.9457 55.2378 32.2378C55.5308 31.5298 56.0272 30.9246 56.6642 30.4989C57.3011 30.0731 58.0501 29.8458 58.8163 29.8458C59.8384 29.8444 60.8195 30.2476 61.5452 30.9674C62.2708 31.6871 62.6821 32.6649 62.6891 33.687V33.7133Z",
    fill: "#093269"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00488 74.5791H35.0995L39.6309 79.1105H184.419",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.326 87.4992V32.2109H143.184V13.1738",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3268 20.3776L93.1066 20.0246L92.9433 19.092L92.0844 19.0235C91.975 18.737 91.8317 18.4646 91.6576 18.2121L92.095 17.4639L91.4258 16.7947L90.6776 17.2425C90.2441 16.9495 89.7541 16.7503 89.2391 16.6577L89.0231 15.7988H88.0747L87.8534 16.663C87.5612 16.7197 87.2766 16.8099 87.005 16.9317L86.3253 16.3468L85.5508 16.8737L85.8722 17.7115C85.6681 17.9242 85.4911 18.1614 85.3453 18.4176L84.4548 18.328L84.1334 19.2184L84.8711 19.7454C84.8346 19.9523 84.8169 20.1622 84.8184 20.3724C84.813 20.4601 84.813 20.5481 84.8184 20.6358L84.0386 21.0732L84.2862 21.9847H85.1662C85.2919 22.2609 85.4531 22.5195 85.6456 22.754L85.2663 23.5443L85.9934 24.1503L86.6942 23.6497C86.9612 23.8034 87.2461 23.9238 87.5425 24.008L87.69 24.8511L88.6332 24.9301L88.9177 24.1292C89.2269 24.103 89.5314 24.0375 89.824 23.9343L90.4194 24.5349L91.2414 24.066L91.0148 23.2493C91.2536 23.0466 91.4661 22.8147 91.6471 22.559L92.4796 22.7118L92.8801 21.853L92.2267 21.3261C92.2997 21.0154 92.3333 20.6967 92.3268 20.3776ZM90.9252 20.3776C90.9252 20.8458 90.7863 21.3034 90.5262 21.6926C90.266 22.0817 89.8962 22.385 89.4636 22.5639C89.031 22.7428 88.555 22.7893 88.0959 22.6976C87.6369 22.6059 87.2153 22.38 86.8847 22.0486C86.554 21.7173 86.3291 21.2952 86.2384 20.8359C86.1477 20.3767 86.1953 19.9008 86.3752 19.4686C86.5551 19.0364 86.8591 18.6673 87.2489 18.408C87.6386 18.1487 88.0966 18.0108 88.5647 18.0118C89.1889 18.0118 89.7877 18.2591 90.2301 18.6995C90.6725 19.1399 90.9224 19.7376 90.9252 20.3618V20.3776Z",
    fill: "#093269"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.324 31.0632L105.104 30.7102L104.94 29.7775L104.081 29.709C103.974 29.4209 103.828 29.1481 103.649 28.8976L104.092 28.1494L103.423 27.4855L102.669 27.9334C102.239 27.6374 101.75 27.4362 101.236 27.3432L101.02 26.4844H100.072L99.8504 27.3485C99.5581 27.4071 99.2735 27.499 99.0021 27.6225L98.3224 27.0376L97.5479 27.5645L97.8693 28.4023C97.6652 28.615 97.4882 28.8522 97.3424 29.1084L96.4519 29.0135L96.1305 29.904L96.8682 30.4045C96.8319 30.6133 96.8142 30.8249 96.8155 31.0368C96.8102 31.1246 96.8102 31.2126 96.8155 31.3003L96.0356 31.7376L96.2833 32.6492H97.1632C97.2914 32.924 97.4524 33.1823 97.6427 33.4185L97.2633 34.2035L97.9905 34.8148L98.6913 34.2878C98.9579 34.4423 99.2429 34.5626 99.5396 34.6461L99.6818 35.4945L100.625 35.5788L100.91 34.7779C101.218 34.7473 101.523 34.6801 101.816 34.5777L102.411 35.1836L103.233 34.7094L103.007 33.8927C103.246 33.692 103.458 33.4618 103.639 33.2077L104.471 33.3605L104.872 32.5016L104.218 31.9747C104.29 31.6762 104.326 31.3702 104.324 31.0632ZM102.922 31.0632C102.922 31.5311 102.784 31.9885 102.524 32.3776C102.264 32.7666 101.894 33.0698 101.462 33.2489C101.03 33.428 100.554 33.4748 100.095 33.3835C99.636 33.2922 99.2145 33.0669 98.8836 32.7361C98.5528 32.4052 98.3274 31.9837 98.2361 31.5247C98.1449 31.0658 98.1917 30.5901 98.3708 30.1578C98.5498 29.7255 98.8531 29.356 99.2421 29.0961C99.6312 28.8361 100.089 28.6974 100.557 28.6974C101.181 28.6974 101.781 28.9444 102.224 29.3847C102.667 29.825 102.918 30.4227 102.922 31.0474V31.0632Z",
    fill: "#093269"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9991 72.3147C25.751 72.3147 27.1711 70.8945 27.1711 69.1427C27.1711 67.3908 25.751 65.9707 23.9991 65.9707C22.2473 65.9707 20.8271 67.3908 20.8271 69.1427C20.8271 70.8945 22.2473 72.3147 23.9991 72.3147Z",
    fill: "#093269"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 71.6339C25.376 71.6339 26.4919 70.5181 26.4919 69.1417C26.4919 67.7652 25.376 66.6494 23.9996 66.6494C22.6232 66.6494 21.5073 67.7652 21.5073 69.1417C21.5073 70.5181 22.6232 71.6339 23.9996 71.6339Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0931 61.5908H55.7173V74.0521H81.0931V61.5908Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.033 35.7627H46.6572V87.4258H72.033V35.7627Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.745 82.6627H78.8848L84.7756 48.0713H131.855L137.745 82.6627Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4274 49.8096H86.5366V54.1144H92.4274V49.8096Z",
    fill: "#093269"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.131 49.8096H94.2397V54.1144H100.131V49.8096Z",
    fill: "#093269"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.548 49.8096H113.047V54.1144H127.548V49.8096Z",
    fill: "#093269"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.501 52.835H74.1299V87.4263H142.501V52.835Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.585 55.9277H99.6787V65.2171H100.585V55.9277Z",
    fill: "#093269"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.756 55.9277H102.85V65.2171H103.756V55.9277Z",
    fill: "#093269"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.927 55.9277H106.021V65.2171H106.927V55.9277Z",
    fill: "#093269"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M132.304 55.9277H131.398V65.2171H132.304V55.9277Z",
    fill: "#093269"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.482 55.9277H134.576V65.2171H135.482V55.9277Z",
    fill: "#093269"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M138.654 55.9277H137.748V65.2171H138.654V55.9277Z",
    fill: "#093269"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.501 63.8574H74.1299V71.7874H142.501V63.8574Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.625 65.2168H100.586V67.2559H102.625V65.2168Z",
    fill: "#093269"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.044 65.2168H105.004V67.2559H107.044V65.2168Z",
    fill: "#093269"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.462 65.2168H109.423V67.2559H111.462V65.2168Z",
    fill: "#093269"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102.625 68.5039H100.586V70.543H102.625V68.5039Z",
    fill: "#093269"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.044 68.5039H105.004V70.543H107.044V68.5039Z",
    fill: "#093269"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M111.462 68.5039H109.423V70.543H111.462V68.5039Z",
    fill: "#093269"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8179 72.582H58.7788V74.6212H60.8179V72.582Z",
    fill: "#093269"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.233 72.582H63.1938V74.6212H65.233V72.582Z",
    fill: "#093269"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6549 72.582H67.6157V74.6212H69.6549V72.582Z",
    fill: "#093269"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.74 68.5039H129.701V70.543H131.74V68.5039Z",
    fill: "#093269"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M136.154 68.5039H134.115V70.543H136.154V68.5039Z",
    fill: "#093269"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.577 68.5039H138.538V70.543H140.577V68.5039Z",
    fill: "#093269"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M142.501 71.7871H74.1299V74.9591H142.501V71.7871Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2252 51.6221C70.2252 51.8462 70.1587 52.0652 70.0342 52.2515C69.9098 52.4378 69.7328 52.583 69.5258 52.6687C69.3188 52.7545 69.0911 52.7769 68.8713 52.7332C68.6516 52.6895 68.4497 52.5816 68.2913 52.4231C68.1328 52.2647 68.025 52.0629 67.9812 51.8431C67.9375 51.6234 67.96 51.3956 68.0457 51.1886C68.1314 50.9816 68.2767 50.8047 68.4629 50.6802C68.6492 50.5557 68.8683 50.4893 69.0923 50.4893C69.3928 50.4893 69.6809 50.6086 69.8934 50.8211C70.1058 51.0335 70.2252 51.3217 70.2252 51.6221Z",
    fill: "#093269"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9957 38.9766C61.9957 39.2007 61.9292 39.4197 61.8048 39.606C61.6803 39.7923 61.5034 39.9375 61.2964 40.0232C61.0894 40.109 60.8616 40.1314 60.6418 40.0877C60.4221 40.044 60.2202 39.9361 60.0618 39.7776C59.9034 39.6192 59.7955 39.4174 59.7517 39.1976C59.708 38.9779 59.7305 38.7501 59.8162 38.5431C59.902 38.3361 60.0472 38.1591 60.2335 38.0347C60.4197 37.9102 60.6388 37.8438 60.8628 37.8438C61.1633 37.8438 61.4514 37.9631 61.6639 38.1756C61.8763 38.388 61.9957 38.6761 61.9957 38.9766Z",
    fill: "#093269"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2252 38.9766C70.2252 39.2007 70.1587 39.4197 70.0342 39.606C69.9098 39.7923 69.7328 39.9375 69.5258 40.0232C69.3188 40.109 69.0911 40.1314 68.8713 40.0877C68.6516 40.044 68.4497 39.9361 68.2913 39.7776C68.1328 39.6192 68.025 39.4174 67.9812 39.1976C67.9375 38.9779 67.96 38.7501 68.0457 38.5431C68.1314 38.3361 68.2767 38.1591 68.4629 38.0347C68.6492 37.9102 68.8683 37.8438 69.0923 37.8438C69.3923 37.8451 69.6797 37.9649 69.8918 38.1771C70.104 38.3892 70.2238 38.6766 70.2252 38.9766Z",
    fill: "#093269"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2252 57.9668C70.2252 58.1909 70.1587 58.4099 70.0342 58.5962C69.9098 58.7825 69.7328 58.9277 69.5258 59.0134C69.3188 59.0992 69.0911 59.1216 68.8713 59.0779C68.6516 59.0342 68.4497 58.9263 68.2913 58.7679C68.1328 58.6094 68.025 58.4076 67.9812 58.1878C67.9375 57.9681 67.96 57.7403 68.0457 57.5333C68.1314 57.3263 68.2767 57.1494 68.4629 57.0249C68.6492 56.9004 68.8683 56.834 69.0923 56.834C69.3928 56.834 69.6809 56.9533 69.8934 57.1658C70.1058 57.3782 70.2252 57.6664 70.2252 57.9668Z",
    fill: "#093269"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2252 64.3106C70.2252 64.5346 70.1587 64.7537 70.0342 64.94C69.9098 65.1262 69.7328 65.2715 69.5258 65.3572C69.3188 65.4429 69.0911 65.4654 68.8713 65.4217C68.6516 65.3779 68.4497 65.2701 68.2913 65.1116C68.1328 64.9532 68.025 64.7513 67.9812 64.5316C67.9375 64.3118 67.96 64.0841 68.0457 63.8771C68.1314 63.6701 68.2767 63.4931 68.4629 63.3687C68.6492 63.2442 68.8683 63.1777 69.0923 63.1777C69.3928 63.1777 69.6809 63.2971 69.8934 63.5095C70.1058 63.722 70.2252 64.0101 70.2252 64.3106Z",
    fill: "#093269"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9108 57.9671C82.9108 57.3418 82.7254 56.7306 82.378 56.2107C82.0306 55.6908 81.5368 55.2856 80.9592 55.0463C80.3815 54.807 79.7458 54.7444 79.1326 54.8664C78.5193 54.9884 77.956 55.2895 77.5139 55.7316C77.0717 56.1738 76.7706 56.7371 76.6486 57.3503C76.5267 57.9636 76.5893 58.5993 76.8285 59.1769C77.0678 59.7546 77.473 60.2484 77.9929 60.5957C78.5128 60.9431 79.1241 61.1285 79.7493 61.1285C80.5878 61.1285 81.3919 60.7955 81.9848 60.2026C82.5777 59.6097 82.9108 58.8056 82.9108 57.9671Z",
    fill: "#093269"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2306 57.9659C82.2306 57.473 82.0845 56.9911 81.8106 56.5813C81.5367 56.1714 81.1475 55.852 80.6921 55.6633C80.2367 55.4747 79.7356 55.4254 79.2521 55.5215C78.7687 55.6177 78.3246 55.855 77.9761 56.2036C77.6275 56.5521 77.3901 56.9962 77.294 57.4797C77.1978 57.9631 77.2472 58.4642 77.4358 58.9196C77.6244 59.375 77.9439 59.7643 78.3537 60.0381C78.7636 60.312 79.2454 60.4582 79.7384 60.4582C80.3993 60.4582 81.0333 60.1956 81.5007 59.7282C81.968 59.2608 82.2306 58.6269 82.2306 57.9659V57.9659Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2335 63.4036C65.2335 62.7783 65.0481 62.1671 64.7007 61.6472C64.3533 61.1273 63.8596 60.7221 63.2819 60.4828C62.7042 60.2436 62.0686 60.181 61.4553 60.3029C60.8421 60.4249 60.2787 60.726 59.8366 61.1681C59.3945 61.6103 59.0934 62.1736 58.9714 62.7869C58.8494 63.4001 58.912 64.0358 59.1513 64.6134C59.3906 65.1911 59.7958 65.6849 60.3157 66.0323C60.8356 66.3796 61.4468 66.5651 62.0721 66.5651C62.9106 66.5651 63.7147 66.232 64.3076 65.6391C64.9004 65.0462 65.2335 64.2421 65.2335 63.4036Z",
    fill: "#093269"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5534 63.4044C64.5534 62.9115 64.4072 62.4296 64.1334 62.0198C63.8595 61.6099 63.4703 61.2905 63.0149 61.1018C62.5595 60.9132 62.0583 60.8638 61.5749 60.96C61.0914 61.0562 60.6474 61.2935 60.2988 61.6421C59.9503 61.9906 59.7129 62.4347 59.6167 62.9182C59.5206 63.4016 59.5699 63.9027 59.7586 64.3581C59.9472 64.8135 60.2666 65.2028 60.6765 65.4766C61.0863 65.7505 61.5682 65.8966 62.0611 65.8966C62.7221 65.8966 63.356 65.6341 63.8234 65.1667C64.2908 64.6993 64.5534 64.0654 64.5534 63.4044V63.4044Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3569 70.4277H52.7729V86.2876",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6764 42.1063H59.1161L54.474 37.459H47.7876",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M109.873 56.6064H114.177",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M109.873 58.4199H114.177",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M109.873 60.2324H114.177",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M154.433 41.2636C154.011 41.1547 153.565 41.1845 153.16 41.3487C152.756 41.5128 152.416 41.8026 152.189 42.1751C151.356 43.5029 152.273 46.7434 152.605 47.5759C152.937 48.4084 154.265 47.9079 154.265 47.9079L154.681 48.9617L155.845 48.7983V47.3019C156.351 46.0946 156.578 44.7889 156.509 43.4818C156.341 41.5112 154.929 41.2636 154.433 41.2636Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M154.273 55.9277L148.319 56.0911L155.005 56.9078L154.273 55.9277Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M152.274 69.6644C152.274 69.6644 152.005 75.7765 151.837 78.1845C151.668 80.5924 151.589 86.1565 151.589 86.1565H152.253L153.581 75.8608L154.35 69.5801L152.274 69.6644Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M155.012 69.5801L156.24 78.685L159.723 86.1565H160.392L157.647 78.2688L157.42 69.6644L155.012 69.5801Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M151.588 86.1562L149.844 88.0689L152.252 87.1574V86.1562H151.588Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M159.723 86.1562L157.979 88.0689L160.392 87.1574V86.1562H159.723Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M154.682 48.9827C154.682 48.9827 152.77 52.8027 152.77 53.3033C152.77 53.8039 154.182 56.5438 154.182 56.5438L151.684 73.7262H158.492L157.923 64.6792C158.149 63.0445 158.063 61.3817 157.67 59.779C157.006 57.6239 156.426 56.1275 156.426 56.1275L157.253 52.4708L155.847 48.8193L154.682 48.9827Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M156.508 43.5029C156.339 41.5112 154.927 41.2636 154.432 41.2636C154.009 41.1547 153.563 41.1845 153.159 41.3487C152.755 41.5128 152.414 41.8026 152.187 42.1751C152.09 42.3399 152.015 42.5172 151.966 42.702C152.206 42.5178 152.506 42.4293 152.808 42.4537C153.11 42.478 153.392 42.6134 153.599 42.8338C154.511 43.7453 153.599 44.3302 154.015 44.8255C154.432 45.3208 155.428 44.9098 155.259 45.7423C155.164 46.0287 155.171 46.3394 155.28 46.621C155.388 46.9026 155.592 47.1378 155.854 47.2861C156.353 46.0899 156.576 44.797 156.508 43.5029Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M159.582 43.819C159.582 44.1316 159.489 44.4373 159.315 44.6972C159.142 44.9571 158.895 45.1597 158.606 45.2794C158.317 45.399 157.999 45.4303 157.693 45.3693C157.386 45.3083 157.104 45.1578 156.883 44.9367C156.662 44.7157 156.512 44.434 156.451 44.1274C156.39 43.8207 156.421 43.5029 156.541 43.2141C156.66 42.9252 156.863 42.6784 157.123 42.5047C157.383 42.331 157.688 42.2383 158.001 42.2383C158.42 42.2383 158.822 42.4048 159.119 42.7013C159.415 42.9977 159.582 43.3998 159.582 43.819Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M145.792 53.9721L149.38 60.0052L149.954 59.6785L146.366 53.5664L145.792 53.9721Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M156.008 50.9799C155.893 50.9319 155.769 50.9118 155.646 50.9212C155.522 50.9307 155.403 50.9695 155.297 51.0344C155.191 51.0993 155.103 51.1884 155.038 51.2944C154.974 51.4004 154.936 51.5202 154.927 51.6438C154.764 52.6397 154.1 57.1236 154.1 57.1236H147.372L148.035 57.7032L155.175 58.5357L156.424 52.7398C156.518 52.5988 156.583 52.4398 156.613 52.2728C156.643 52.1057 156.639 51.9342 156.6 51.769C156.561 51.6038 156.488 51.4484 156.386 51.3126C156.284 51.1768 156.155 51.0636 156.008 50.9799V50.9799Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M124.965 60.1055H123.126V63.2511H124.965V60.1055Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M122.457 58.6729H121.714V60.1587H122.457V58.6729Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M126.283 58.6729H125.541V60.1587H126.283V58.6729Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M123.994 56.2695H123.989C123.078 56.2695 122.34 57.0079 122.34 57.9187V60.4268C122.34 61.3377 123.078 62.076 123.989 62.076H123.994C124.905 62.076 125.644 61.3377 125.644 60.4268V57.9187C125.644 57.0079 124.905 56.2695 123.994 56.2695Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M119.307 75.4277L116.499 75.7808L117.373 87.0197H118.164L118.427 78.4996L120.361 78.3468L119.307 75.4277Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M128.262 75.4277L131.071 75.7808L130.196 87.0197H129.406L129.142 78.4996L127.208 78.3468L128.262 75.4277Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M117.987 62.54H129.843L127.076 78.3472H120.358L117.987 62.54Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M117.989 62.54L114.765 68.336L113.579 66.0967L112.852 66.2969L114.37 70.8388L118.516 66.8238L117.989 62.54Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M129.846 62.5393L133.281 62.6236L134.53 59.7256L135.252 59.9258L133.739 64.4677L129.055 66.8862L129.846 62.5393Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M113.578 66.097L114.037 65.7703V65.0431L113.895 65.0115L113.668 65.2961L113.115 64.3213L112.435 64.8482L112.851 66.2972L113.578 66.097Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M134.526 59.7259L134.062 59.3992V58.6721L134.205 58.6457L134.431 58.925L134.985 57.9502L135.67 58.4771L135.248 59.9261L134.526 59.7259Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M124.463 78.9424H123.035V84.8279H124.463V78.9424Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M131.786 87.6363L124.805 86.1873V81.4873H122.697V86.1873L115.716 87.6363V88.511L123.224 87.3465V88.6058H124.278V87.3518L131.786 88.5162V87.6363Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M128.183 79.2899H119.294L118.25 65.7695H129.226L128.183 79.2899Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M125.803 61.8184H122.205V62.5191H125.803V61.8184Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9912 60.1055H86.1523V63.2511H87.9912V60.1055Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4832 58.6729H84.7402V60.1587H85.4832V58.6729Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3093 58.6729H88.5664V60.1587H89.3093V58.6729Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0149 62.076C86.5775 62.076 86.1581 61.9023 85.8488 61.593C85.5395 61.2837 85.3657 60.8642 85.3657 60.4268V57.924C85.3657 57.4861 85.5393 57.0661 85.8484 56.756C86.1576 56.4458 86.5771 56.2709 87.0149 56.2695C87.4533 56.2709 87.8733 56.4457 88.1833 56.7557C88.4933 57.0656 88.668 57.4856 88.6694 57.924V60.4268C88.668 60.8647 88.4931 61.2842 88.183 61.5933C87.8729 61.9024 87.4528 62.076 87.0149 62.076Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3328 75.4277L79.5244 75.7808L80.4043 87.0197H81.1947L81.4582 78.4996L83.3866 78.3468L82.3328 75.4277Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2882 75.4277L94.1019 75.7808L93.2219 87.0197H92.4316L92.1681 78.4996L90.2344 78.3468L91.2882 75.4277Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0132 62.54H92.8686L90.1023 78.3472H83.3843L81.0132 62.54Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0153 62.54L77.7906 68.336L76.6051 66.0967L75.8779 66.2969L77.3954 70.8388L81.5422 66.8238L81.0153 62.54Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8719 62.54L96.1018 68.336L97.2874 66.0967L98.0092 66.2969L96.497 70.8388L92.0815 66.887L92.8719 62.54Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6043 66.097L77.0627 65.7703V65.0431L76.9205 65.0115L76.6992 65.2961L76.1407 64.3213L75.4609 64.8482L75.8772 66.2972L76.6043 66.097Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2855 66.097L96.8218 65.7703V65.0431L96.9641 65.0115L97.1906 65.2961L97.7439 64.3213L98.4236 64.8482L98.0073 66.2972L97.2855 66.097Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4963 78.9424H86.0684V84.8279H87.4963V78.9424Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8155 87.6363L87.834 86.1873V81.4873H85.7264V86.1873L78.7344 87.6363V88.511L86.2428 87.3465V88.6058H87.2966V87.3518L94.805 88.5162L94.8155 87.6363Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2143 79.2899H82.3201L81.2769 65.7695H92.2576L91.2143 79.2899Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8292 61.8184H85.2305V62.5191H88.8292V61.8184Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9556 44.3445V41.652C49.9534 41.2685 50.0776 40.895 50.3091 40.5893C50.5405 40.2835 50.8663 40.0626 51.236 39.9606C51.5605 39.878 51.8922 39.8269 52.2266 39.8078C52.729 39.7673 53.2299 39.9028 53.6433 40.1913C54.0567 40.4797 54.3569 40.903 54.4923 41.3885C54.7557 42.0841 54.4923 45.8356 54.4923 45.8356C54.3511 46.015 54.1517 46.1395 53.9285 46.1876C53.7053 46.2357 53.4724 46.2044 53.2698 46.0991V46.979H50.0452L49.9556 44.3445Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4962 41.3726C54.3599 40.8876 54.0595 40.4649 53.6463 40.1766C53.2331 39.8883 52.7327 39.7523 52.2305 39.7919C51.8961 39.8109 51.5644 39.8621 51.2399 39.9447C50.8702 40.0466 50.5444 40.2676 50.313 40.5733C50.0815 40.8791 49.9573 41.2526 49.9595 41.636V44.3443L49.9964 45.4719C50.3249 45.6827 50.7026 45.8043 51.0923 45.8249C51.5259 45.8804 51.9665 45.8304 52.3766 45.679C52.7866 45.5276 53.1541 45.2794 53.4476 44.9555L52.7521 44.5182L52.4043 42.9375L53.1894 42.7636L53.4476 43.8965H53.8849L53.8006 42.5897H54.3275L54.4962 41.3726Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M53.966 46.7783H49.0815V48.0007H53.966V46.7783Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8967 55.8517L47.4258 52.3636L48.7325 59.3451H55.4506L56.4096 52.8905L60.5985 54.1076L63.8284 45.909L62.9537 45.6455L59.9029 50.9673L56.4991 47.7373H46.9885L42.8892 55.33L46.5512 62.0481L47.3362 61.7846L44.8967 55.8517Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7321 59.3457L48.4686 62.8338L45.9395 87.003H46.9037L51.962 64.757H52.5732L58.1531 86.6552H59.2913L55.7979 62.1383L55.4501 59.3457H48.7321Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9551 45.6463L64.1775 42.332L64.6148 42.4163L64.4409 43.291L65.4842 43.8126L65.0522 45.3828H64.5253L63.8297 45.9097L62.9551 45.6463Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3354 61.7852L48.2101 63.7189L47.425 64.151L46.5503 62.0486L47.3354 61.7852Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2905 86.6553L61.3138 88.0674H58.2367L58.1523 86.6553H59.2905Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8911 86.6553L43.873 88.0674H46.9449L47.0292 86.6553H45.8911Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M109.086 118.111H144.916V150.253H109.086C108.86 150.253 108.643 150.163 108.482 150.003C108.322 149.842 108.232 149.625 108.232 149.399V118.944C108.238 118.721 108.33 118.509 108.49 118.354C108.649 118.198 108.863 118.111 109.086 118.111V118.111Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M146.15 118.102H109.198V150.269H146.15V118.102Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M144.132 120.651H112.043V147.724H144.132V120.651Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M114.481 145.664H123.66V122.712H114.481V145.664Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M114.481 145.669H141.685V124.503H114.481V145.669Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M115.899 144.568H140.273V125.605H115.899V144.568Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M116.963 131.79H121.505",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M116.963 133.171H121.505",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M116.963 134.546H121.505",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M116.963 136.886H136.917",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M116.963 138.672H136.917",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M116.963 140.464H136.917",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M109.198 150.274L130.728 157.403H168.491L146.15 150.274H109.198Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M136.086 153.019L132.972 152.024L131.444 152.008L134.547 153.009L136.086 153.019Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M139.124 153.045L135.999 152.055L134.487 152.039L137.611 153.03L139.124 153.045Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M149.796 154.1L151.255 154.105L148.004 153.109L146.55 153.099L149.796 154.1Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M134.546 153.009L131.442 152.008L129.904 151.997L132.997 152.998L134.546 153.009Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M131.439 152.988L128.351 151.982L126.792 151.966L129.869 152.977L131.439 152.988Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M145.083 153.088L141.927 152.108L140.457 152.098L143.607 153.078L145.083 153.088Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M146.548 153.098L143.381 152.123L141.927 152.107L145.083 153.087L146.548 153.098Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M129.867 152.978L126.79 151.966L125.215 151.95L128.287 152.962L129.867 152.978Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M140.633 153.057L137.498 152.066L136.001 152.056L139.126 153.046L140.633 153.057Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M148.003 153.109L144.826 152.14L143.382 152.124L146.549 153.099L148.003 153.109Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M143.609 153.078L140.458 152.098L138.982 152.082L142.128 153.067L143.609 153.078Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M142.129 153.067L138.983 152.081L137.497 152.065L140.632 153.056L142.129 153.067Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M137.611 153.03L134.487 152.039L132.969 152.023L136.083 153.019L137.611 153.03Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M126.69 152.951L125.083 152.94L128.218 153.989L129.83 153.999L126.69 152.951Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M123.628 151.934L122.037 151.918L125.082 152.94L126.689 152.951L123.628 151.934Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M128.285 152.961L125.213 151.949L123.627 151.934L126.689 152.951L128.285 152.961Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M131.426 155.063L134.729 156.17H136.363L133.054 155.069L131.426 155.063Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M129.83 154L128.218 153.989L131.427 155.064L133.055 155.069L129.83 154Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M133.053 155.069L136.362 156.171H137.985L134.666 155.075L133.053 155.069Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M132.997 152.998L129.904 151.997L128.35 151.981L131.437 152.988L132.997 152.998Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M136.173 154.032L132.996 152.999L131.437 152.988L134.603 154.021L136.173 154.032Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M134.604 154.021L131.437 152.988L129.867 152.978L133.023 154.016L134.604 154.021Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M137.735 154.036L134.548 153.009L132.999 152.998L136.176 154.031L137.735 154.036Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M128.285 152.961L126.689 152.95L129.829 153.999L131.431 154.004L128.285 152.961Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M153.124 155.122L154.589 155.127L151.254 154.105L149.794 154.1L153.124 155.122Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M133.024 154.016L129.868 152.978L128.287 152.962L131.433 154.005L133.024 154.016Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M129.831 153.999L133.056 155.069L134.668 155.074L131.433 154.004L129.831 153.999Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M146.844 154.083L143.609 153.077L142.128 153.066L145.353 154.073L146.844 154.083Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M145.353 154.074L142.128 153.067L140.632 153.057L143.846 154.068L145.353 154.074Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M149.794 154.1L146.548 153.098L145.083 153.088L148.323 154.089L149.794 154.1Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M140.812 154.052L137.613 153.03L136.085 153.02L139.278 154.042L140.812 154.052Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M143.846 154.068L140.632 153.056L139.125 153.046L142.334 154.058L143.846 154.068Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M142.335 154.058L139.126 153.046L137.614 153.03L140.813 154.052L142.335 154.058Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M139.277 154.042L136.084 153.019L134.545 153.009L137.733 154.036L139.277 154.042Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M143.847 154.068L147.151 155.106L148.658 155.112L145.354 154.074L143.847 154.068Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M145.354 154.073L148.658 155.111L150.159 155.117L146.845 154.084L145.354 154.073Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M131.433 154.005L134.668 155.075L136.27 155.08L133.024 154.015L131.433 154.005Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M146.843 154.084L150.157 155.117H151.643L148.323 154.089L146.843 154.084Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M140.811 154.053L144.099 155.096L145.627 155.101L142.334 154.058L140.811 154.053Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M148.324 154.089L151.643 155.116L153.124 155.122L149.794 154.099L148.324 154.089Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M142.333 154.057L145.626 155.1L147.148 155.105L143.845 154.067L142.333 154.057Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M134.604 154.021L137.855 155.085H139.436L136.174 154.031L134.604 154.021Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M133.024 154.015L136.27 155.079L137.856 155.084L134.605 154.02L133.024 154.015Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M139.278 154.042L142.556 155.096H144.1L140.812 154.053L139.278 154.042Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M137.735 154.036L141.002 155.09L142.556 155.095L139.279 154.041L137.735 154.036Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M136.173 154.031L139.435 155.085L141 155.09L137.733 154.037L136.173 154.031Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M148.325 154.09L145.085 153.089L143.609 153.078L146.845 154.085L148.325 154.09Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M123.627 151.934L120.365 150.849L118.785 150.833L122.036 151.918L123.627 151.934Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M122.037 151.918L120.551 151.902L123.592 152.93L125.083 152.94L122.037 151.918Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M118.786 150.833L117.311 150.812L120.551 151.902L122.037 151.918L118.786 150.833Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M125.082 152.94L123.591 152.93L126.71 153.983L128.217 153.989L125.082 152.94Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M128.218 153.99L126.711 153.984L129.92 155.065H131.427L128.218 153.99Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M131.425 155.063H129.918L133.212 156.17H134.729L131.425 155.063Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M149.443 153.12L152.705 154.111L153.98 154.116L150.713 153.131L149.443 153.12Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M156.043 155.127L157.323 155.133L153.977 154.116L152.702 154.11L156.043 155.127Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M159.476 156.17H160.761L157.326 155.132L156.045 155.127L159.476 156.17Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M136.001 152.055L132.66 150.996L131.159 150.98L134.489 152.04L136.001 152.055Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M149.442 153.119L150.712 153.129L147.529 152.165L146.265 152.149L149.442 153.119Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M154.589 155.127H156.043L152.703 154.11L151.254 154.104L154.589 155.127Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M125.216 151.95L121.944 150.87L120.369 150.849L123.63 151.934L125.216 151.95Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M144.827 152.14L148.004 153.109L149.443 153.12L146.266 152.15L144.827 152.14Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M147.528 152.166L144.124 151.133L142.87 151.117L146.263 152.15L147.528 152.166Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M146.263 152.15L142.87 151.117L141.437 151.102L144.825 152.14L146.263 152.15Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M150.16 155.117L153.559 156.171H155.055L151.646 155.117H150.16Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M158.009 156.17H159.474L156.044 155.127H154.589L158.009 156.17Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M144.825 152.14L141.437 151.102L139.999 151.086L143.382 152.124L144.825 152.14Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M153.126 155.121L156.541 156.17H158.011L154.591 155.126L153.126 155.121Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M151.645 155.117L155.054 156.171H156.54L153.126 155.122L151.645 155.117Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M151.253 154.104L152.702 154.11L149.44 153.119L148.002 153.108L151.253 154.104Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M131.443 152.008L128.134 150.944L126.601 150.923L129.905 151.998L131.443 152.008Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M143.381 152.124L139.998 151.086L138.554 151.064L141.926 152.108L143.381 152.124Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M129.903 151.998L126.6 150.923L125.061 150.907L128.349 151.982L129.903 151.998Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M134.489 152.039L131.159 150.98L129.652 150.959L132.971 152.023L134.489 152.039Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M128.349 151.982L125.061 150.907L123.507 150.886L126.789 151.966L128.349 151.982Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M126.789 151.965L123.506 150.885L121.941 150.869L125.213 151.949L126.789 151.965Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M132.971 152.024L129.651 150.959L128.134 150.943L131.443 152.008L132.971 152.024Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M141.926 152.108L138.554 151.065L137.095 151.049L140.456 152.097L141.926 152.108Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M140.456 152.098L137.095 151.049L135.625 151.033L138.981 152.082L140.456 152.098Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M137.495 152.066L134.149 151.012L132.658 150.996L135.999 152.055L137.495 152.066Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M150.157 155.117L148.655 155.112L147.148 155.107L145.626 155.102L144.098 155.096H142.554L140.999 155.091L139.435 155.086H137.854L136.268 155.08L134.666 155.075L137.986 156.171H139.598H141.194H142.78H144.356H145.915H147.465H149.008H150.531H152.049H153.556L150.157 155.117Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M138.982 152.081L135.626 151.033L134.15 151.012L137.496 152.066L138.982 152.081Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M109.198 150.274V151.349L130.717 158.779L130.728 157.403L109.198 150.274Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M168.49 157.403H130.727V158.779H168.49V157.403Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M120.31 106.209L128.561 118.797L136.818 106.209H133.362V90.6865H123.761V106.209H120.31Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4999 150.265H45.6703L45.6703 118.123H81.4999C81.7263 118.123 81.9434 118.213 82.1035 118.373C82.2636 118.533 82.3535 118.751 82.3535 118.977V149.432C82.348 149.655 82.2557 149.867 82.0962 150.022C81.9367 150.178 81.7227 150.265 81.4999 150.265V150.265Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4324 150.275H81.3843V118.108H44.4324L44.4324 150.275Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M46.45 147.725H78.5386V120.652H46.45V147.725Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8955 145.665H58.0742V122.713H48.8955V145.665Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M48.895 145.67H76.0991V124.504H48.895V145.67Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3089 144.568H74.6836V125.605H50.3089V144.568Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M51.377 131.791H55.9136",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M51.377 133.172H55.9136",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M51.377 134.548H55.9136",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M51.377 136.887H71.3256",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M51.377 138.673H71.3256",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M51.377 140.465H71.3256",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3851 150.275L59.861 157.404H22.0977L44.4385 150.275H81.3851Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5005 153.02L57.6092 152.025L59.1425 152.009L56.0391 153.01L54.5005 153.02Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4575 153.046L54.5873 152.056L56.0943 152.04L52.975 153.031L51.4575 153.046Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7921 154.1L39.3325 154.105L42.5835 153.109L44.0378 153.099L40.7921 154.1Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0405 153.01L59.144 152.009L60.6826 151.998L57.5844 152.999L56.0405 153.01Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1494 152.989L62.2318 151.983L63.7967 151.967L60.7196 152.978L59.1494 152.989Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5029 153.089L48.6591 152.109L50.1292 152.099L46.973 153.079L45.5029 153.089Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0361 153.099L47.2028 152.124L48.6571 152.108L45.5009 153.088L44.0361 153.099Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7188 152.978L63.7959 151.966L65.3661 151.95L62.2995 152.962L60.7188 152.978Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9541 153.057L53.0892 152.066L54.5856 152.056L51.4558 153.046L49.9541 153.057Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M42.584 153.109L45.756 152.14L47.205 152.124L44.0382 153.099L42.584 153.109Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9731 153.078L50.1293 152.098L51.6047 152.082L48.459 153.067L46.9731 153.078Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M48.458 153.068L51.6036 152.082L53.0895 152.066L49.9544 153.057L48.458 153.068Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9756 153.031L56.0949 152.04L57.6124 152.024L54.5036 153.02L52.9756 153.031Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8905 152.952L65.4975 152.941L62.3677 153.99L60.7554 154L63.8905 152.952Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9549 151.936L68.5514 151.92L65.5006 152.942L63.8936 152.953L66.9549 151.936Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2988 152.962L65.3654 151.95L66.9514 151.935L63.8901 152.951L62.2988 152.962Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1559 155.065L55.8574 156.172H54.2188L57.533 155.071L59.1559 155.065Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7574 154L62.3697 153.989L59.1556 155.064L57.5327 155.069L60.7574 154Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5305 155.069L54.2162 156.171H52.5986L55.9181 155.075L57.5305 155.069Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M57.584 152.999L60.6822 151.998L62.2313 151.982L59.1489 152.989L57.584 152.999Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4126 154.032L57.5846 152.999L59.1495 152.988L55.9775 154.021L54.4126 154.032Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9785 154.022L59.1505 152.989L60.7207 152.979L57.5592 154.017L55.9785 154.022Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8545 154.037L56.0423 153.01L57.5861 152.999L54.4141 154.032L52.8545 154.037Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3003 152.963L63.8916 152.952L60.7565 154.001L59.1494 154.006L62.3003 152.963Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4614 155.123L35.9966 155.128L39.3319 154.106L40.7914 154.101L37.4614 155.123Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5586 154.017L60.72 152.979L62.3007 152.963L59.1498 154.006L57.5586 154.017Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7569 154.001L57.5323 155.071L55.9199 155.076L59.1498 154.006L60.7569 154.001Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7437 154.085L46.9736 153.079L48.4595 153.068L45.2348 154.075L43.7437 154.085Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2319 154.074L48.4566 153.067L49.953 153.057L46.7336 154.068L45.2319 154.074Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7915 154.101L44.0372 153.099L45.502 153.089L42.2616 154.09L40.7915 154.101Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7715 154.053L52.9751 153.031L54.5031 153.021L51.3101 154.043L49.7715 154.053Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7354 154.069L49.9547 153.057L51.4564 153.047L48.2476 154.059L46.7354 154.069Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2461 154.058L51.455 153.046L52.9724 153.03L49.7689 154.052L48.2461 154.058Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3076 154.042L54.5007 153.02L56.0392 153.01L52.8514 154.037L51.3076 154.042Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7364 154.069L43.438 155.107L41.9258 155.113L45.2347 154.075L46.7364 154.069Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2351 154.074L41.9261 155.112L40.4297 155.117L43.7439 154.085L45.2351 154.074Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1496 154.006L55.9197 155.075L54.3179 155.081L57.5583 154.016L59.1496 154.006Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M43.741 154.085L40.4268 155.118H38.9409L42.2604 154.09L43.741 154.085Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M49.77 154.053L46.4874 155.096L44.9541 155.101L48.2473 154.058L49.77 154.053Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2635 154.09L38.944 155.117L37.4634 155.123L40.7934 154.1L42.2635 154.09Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2467 154.059L44.9535 155.102L43.436 155.107L46.7345 154.069L48.2467 154.059Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9769 154.021L52.7258 155.086H51.1504L54.4119 154.032L55.9769 154.021Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5583 154.017L54.3178 155.081L52.7266 155.086L55.9776 154.022L57.5583 154.017Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M51.308 154.043L48.0307 155.097H46.4868L49.7694 154.054L51.308 154.043Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8515 154.037L49.5846 155.091L48.0303 155.096L51.3076 154.042L52.8515 154.037Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4114 154.032L51.1499 155.086L49.585 155.091L52.8518 154.037L54.4114 154.032Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2622 154.09L45.5027 153.089L46.9727 153.078L43.7428 154.085L42.2622 154.09Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9512 151.935L70.2127 150.85L71.7987 150.834L68.5477 151.919L66.9512 151.935Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5498 151.919L70.0357 151.903L66.9954 152.931L65.499 152.941L68.5498 151.919Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8008 150.835L73.2762 150.813L70.0357 151.904L68.5498 151.92L71.8008 150.835Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M65.498 152.941L66.9944 152.931L63.8698 153.984L62.3682 153.99L65.498 152.941Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3674 153.99L63.8691 153.984L60.6655 155.065H59.1533L62.3674 153.99Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1559 155.065H60.6681L57.3749 156.172H55.8574L59.1559 155.065Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1388 153.12L37.8825 154.111L36.6074 154.116L39.869 153.131L41.1388 153.12Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5393 155.128L33.2642 155.134L36.61 154.117L37.8851 154.111L34.5393 155.128Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1118 156.171H29.8262L33.2616 155.133L34.5367 155.128L31.1118 156.171Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M54.585 152.056L57.9256 150.997L59.422 150.981L56.0919 152.041L54.585 152.056Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M41.14 153.12L39.8701 153.13L43.0579 152.166L44.3225 152.15L41.14 153.12Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9966 155.128H34.5371L37.883 154.111L39.3319 154.105L35.9966 155.128Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3677 151.951L68.6398 150.871L70.2152 150.85L66.9537 151.935L65.3677 151.951Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7549 152.141L42.5829 153.11L41.1392 153.121L44.3217 152.151L45.7549 152.141Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0596 152.167L46.4634 151.134L47.7174 151.118L44.3241 152.151L43.0596 152.167Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3213 152.151L47.7146 151.118L49.1425 151.103L45.7545 152.141L44.3213 152.151Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4272 155.117L37.0234 156.171H35.5322L38.9413 155.117H40.4272Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5786 156.171H31.1138L34.5387 155.128H35.9982L32.5786 156.171Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7554 152.141L49.1434 151.103L50.5818 151.087L47.2044 152.125L45.7554 152.141Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4611 155.123L34.0467 156.172H32.5767L35.9963 155.128L37.4611 155.123Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9418 155.117L35.5328 156.171H34.0469L37.4612 155.122L38.9418 155.117Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3328 154.106L37.8838 154.111L41.1401 153.121L42.5838 153.11L39.3328 154.106Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M59.146 152.009L62.455 150.945L63.9883 150.924L60.6846 151.999L59.146 152.009Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2036 152.124L50.5811 151.086L52.0301 151.065L48.6579 152.109L47.2036 152.124Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6821 151.998L63.9858 150.923L65.5244 150.907L62.2312 151.982L60.6821 151.998Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0918 152.04L59.4218 150.981L60.9341 150.96L57.6093 152.024L56.0918 152.04Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2329 151.982L65.5261 150.907L67.0804 150.886L63.7978 151.966L62.2329 151.982Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7983 151.967L67.081 150.887L68.6406 150.871L65.3685 151.951L63.7983 151.967Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6094 152.024L60.9341 150.96L62.4516 150.944L59.1427 152.009L57.6094 152.024Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6592 152.109L52.0314 151.066L53.4909 151.05L50.1293 152.098L48.6592 152.109Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1299 152.099L53.4915 151.05L54.9616 151.034L51.6052 152.083L50.1299 152.099Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0889 152.067L56.4347 151.013L57.9259 150.997L54.5853 152.056L53.0889 152.067Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4282 155.117L41.9246 155.112L43.4369 155.107L44.9543 155.102L46.4876 155.096H48.0315L49.5858 155.091L51.1508 155.086H52.7262L54.3175 155.08L55.9193 155.075L52.5998 156.171H50.9874H49.3909H47.8049H46.2295H44.6698H43.1154H41.5769H40.0488H38.5314H37.0244L40.4282 155.117Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6035 152.083L54.9599 151.035L56.4352 151.014L53.0894 152.067L51.6035 152.083Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M81.383 150.275V151.35L59.8642 158.78L59.8589 157.404L81.383 150.275Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0955 158.779H59.8589V157.404H22.0955V158.779Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6471 99.413L64.3958 86.8252L56.1392 99.413H59.5957V118.45H69.1959V99.413H72.6471Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsync);
export default __webpack_public_path__ + "static/media/Cloudsync.632f57dc1c1c9fc5232d1eb0064aaf61.svg";
export { ForwardRef as ReactComponent };